import React, { useState, useEffect } from "react";
import { LinearProgress } from "@mui/material";

const LinearWithValueLabel = (props) => {
  const pdfData = props.pdfData;
  const [progress, setProgress] = useState(0);
  const [isProgressComplete, setIsProgressComplete] = useState(false);
  const [isTimeEnded, setIsTimeEnded] = useState(false);
  useEffect(() => {
    let interval;
    if (progress === 100) {
      setIsProgressComplete(true);
    } else {
      interval = setInterval(() => {
        const percentageCompleted = calculatePercentageCompleted();
        setProgress(percentageCompleted);
      }, 1000); // Update every second
    }

    return () => clearInterval(interval);
  }, [progress]);

  useEffect(() => {
    if (isProgressComplete && isTimeEnded === false) {
      let interval;
      const currentTime = new Date();
      interval = setInterval(() => {
        const createdAtTime = new Date(pdfData.created_at);
        const elapsedTimeInSeconds = Math.floor((currentTime - createdAtTime) / 1000);
        if (elapsedTimeInSeconds > 0 && elapsedTimeInSeconds < 3600) {
          props.getFileStatusUpdate(props.index, props.pdfData.id);
        } else {
          setIsTimeEnded(!isTimeEnded);
          clearInterval(interval);
        }
      }, 10000);
      return () => clearInterval(interval);
    }
  }, [isProgressComplete]);

  const calculatePercentageCompleted = () => {
    if (pdfData.status === "processing") {
      const currentTime = new Date();
      const createdAtTime = new Date(pdfData.created_at);
      const processingTime = pdfData.processing_time;
      const elapsedTimeInSeconds = Math.floor((currentTime - createdAtTime) / 1000);
      const pendingTimeInSeconds = Math.max(0, processingTime - elapsedTimeInSeconds);
      const percentageCompleted = ((processingTime - pendingTimeInSeconds) / processingTime) * 100;
      return Math.min(percentageCompleted, 100); // Ensure progress does not exceed 100%
    }
    return 0;
  };

  return <>{isProgressComplete ? <LinearProgress variant="determinate" value={100} color="primary" /> : <LinearProgress variant="determinate" value={progress} color="primary" />}</>;
};

export default LinearWithValueLabel;
